import React from 'react';
import PropTypes from 'prop-types';

import './Checkbox.scss';

const CheckboxGroup = ({ children }) => (
  <div className="CheckboxGroup">
    {children}
  </div>
);

CheckboxGroup.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
};

CheckboxGroup.displayName = 'CheckboxGroup';

export default CheckboxGroup;
